import { z } from 'zod';
import { TFunction } from 'i18next';
import { isValidIBAN, isValidBIC } from 'ibantools';
import { trimmedString, sanitizedString } from '../utils/validation';

export const createBankTransferSchema = (t: TFunction) => {
  return z.object({
    beneficiaryName: trimmedString(t).pipe(z.string().max(1000, t('fieldTooLong'))),

    IBAN: sanitizedString(t)
      .pipe(z.string().max(34, t('fieldTooLong')))
      .refine((iban) => isValidIBAN(iban), { error: t('invalidIBAN') }),

    swiftCode: sanitizedString(t)
      .pipe(z.string().max(11, t('fieldTooLong')))
      .refine((bic) => isValidBIC(bic), { error: t('invalidSwiftCode') }),

    bankName: trimmedString(t).pipe(z.string().max(1000, t('fieldTooLong'))),
  });
};

export type BankTransferFormData = z.infer<ReturnType<typeof createBankTransferSchema>>;
